/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import {
  NOTIFICATION_NUMBER,
  ONESIGNAL_SUBSCRIPTION,
  DOCTOR_ONLINE_DATA,
  DOCTOR_ONLINE_STATE,
  DOCTOR_APPOINTMENT_DATA,
  VIDEO_CALL_DATA,
  SESSION_ID,
  IS_TIMER_TIMEOUT,
  SET_FORUM_READ_TOPICS,
  SET_FORUM_READ_COMMENTS,
  SET_ONLINE_ASSESSMENT_START_STATUS,
  SET_USER_ACCESS,
  PATIENT_QUEUE_COUNT_DATA, CONSTANTS, TOTAL_DOCTORS
} from "../constants/commonConstant";

export const notificationNumber = data => ({
  type: NOTIFICATION_NUMBER,
  payload: data
});

export const oneSignalSubscription = data => ({
  type: ONESIGNAL_SUBSCRIPTION,
  payload: data
});

export const doctorOnlineData = data => ({
  type: DOCTOR_ONLINE_DATA,
  payload: data
});

export const patientQueueCountData = data => ({
  type: PATIENT_QUEUE_COUNT_DATA,
  payload: data
});

export const doctorOnlineState = data => ({
  type: DOCTOR_ONLINE_STATE,
  payload: data
});

export const doctorAppointmentData = data => ({
  type: DOCTOR_APPOINTMENT_DATA,
  payload: data
});

export const saveVideoCallData = data => ({
  type: VIDEO_CALL_DATA,
  payload: data
});

export const saveSessionId = data => ({
  type: SESSION_ID,
  payload: data
});

export const saveTimerStatus = data => ({
  type: IS_TIMER_TIMEOUT,
  payload: data
});

export const setForumReadComments = data => ({
  type: SET_FORUM_READ_COMMENTS,
  payload: data
});

export const setForumReadTopics = data => ({
  type: SET_FORUM_READ_TOPICS,
  payload: data
});

export const setOnlineAssessmentStatus = data => ({
  type: SET_ONLINE_ASSESSMENT_START_STATUS,
  payload: data
});

export const setUserAccess = data => ({
  type: SET_USER_ACCESS,
  payload: data
});

export const setConstants = data => ({
  type: CONSTANTS,
  payload: data
});

export const setTotalDoctors = data => ({
  type: TOTAL_DOCTORS,
  payload: data
});
